import { t as e } from "./utils-DiFe-_ei.js";
import { i as t, r as n, t as r } from "./dist-By11B3Nf.js";
import { a as i } from "./dist-7tgynhKG.js";
import { t as a } from "./dist-B3lndwlS.js";
import { t as o } from "./dist-5NoialTu.js";
import * as s from "react";
import { Fragment as c, jsx as l, jsxs as u } from "react/jsx-runtime";
//#region ../../node_modules/.pnpm/@radix-ui+react-switch@1.3.4_@types+react-dom@19.2.3_@types+react@19.2.17__@types+react_3c8ad0e4b6e3b5b02d218a2d5b50cdb3/node_modules/@radix-ui/react-switch/dist/index.mjs
var d = Object.defineProperty, f = (e, t) => d(e, "name", {
	value: t,
	configurable: !0
}), p = "Switch", [m, h] = t(p), [g, _] = m(p);
function v(e) {
	let { __scopeSwitch: t, checked: n, children: i, defaultChecked: a, disabled: o, form: c, name: u, onCheckedChange: d, required: f, value: m = "on", internal_do_not_use_render: h } = e, [_, v] = r({
		prop: n,
		defaultProp: a ?? !1,
		onChange: d,
		caller: p
	}), [y, b] = s.useState(null), [x, S] = s.useState(null), C = s.useRef(!1), [w, T] = s.useReducer((e) => e + 1, 0), D = {
		checked: _,
		setChecked: v,
		disabled: o,
		control: y,
		setControl: b,
		name: u,
		form: c,
		value: m,
		hasConsumerStoppedPropagationRef: C,
		userInteractionCount: w,
		onUserInteraction: T,
		required: f,
		defaultChecked: a,
		isFormControl: !y || !!c || !!y.closest("form"),
		bubbleInput: x,
		setBubbleInput: S
	};
	return /* @__PURE__ */ l(g, {
		scope: t,
		...D,
		children: E(h) ? h(D) : i
	});
}
f(v, "SwitchProvider");
var y = "SwitchTrigger", b = /* @__PURE__ */ s.forwardRef(/* @__PURE__ */ f(function({ __scopeSwitch: e, onClick: t, ...r }, o) {
	let { control: c, form: u, value: d, disabled: p, checked: m, required: h, setControl: g, setChecked: v, hasConsumerStoppedPropagationRef: b, onUserInteraction: x, isFormControl: S, bubbleInput: C } = _(y, e), w = i(o, g), T = s.useRef(m);
	return s.useEffect(() => {
		let e = u ? c?.ownerDocument.getElementById(u) : c?.form;
		if (e instanceof HTMLFormElement) {
			let t = /* @__PURE__ */ f(() => v(T.current), "reset");
			return e.addEventListener("reset", t), () => e.removeEventListener("reset", t);
		}
	}, [
		c,
		u,
		v
	]), /* @__PURE__ */ l(a.button, {
		type: "button",
		role: "switch",
		"aria-checked": m,
		"aria-required": h,
		"data-state": D(m),
		"data-disabled": p ? "" : void 0,
		disabled: p,
		value: d,
		...r,
		ref: w,
		onClick: n(t, (e) => {
			x(), v((e) => !e), C && S && (b.current = e.isPropagationStopped(), b.current || e.stopPropagation());
		})
	});
}, "SwitchTrigger")), x = /* @__PURE__ */ s.forwardRef(/* @__PURE__ */ f(function(e, t) {
	let { __scopeSwitch: n, name: r, checked: i, defaultChecked: a, required: o, disabled: s, value: d, onCheckedChange: f, form: p, ...m } = e;
	return /* @__PURE__ */ l(v, {
		__scopeSwitch: n,
		checked: i,
		defaultChecked: a,
		disabled: s,
		required: o,
		onCheckedChange: f,
		name: r,
		form: p,
		value: d,
		internal_do_not_use_render: ({ isFormControl: e }) => /* @__PURE__ */ u(c, { children: [/* @__PURE__ */ l(b, {
			...m,
			ref: t,
			__scopeSwitch: n
		}), e && /* @__PURE__ */ l(T, { __scopeSwitch: n })] })
	});
}, "Switch")), S = "SwitchThumb", C = /* @__PURE__ */ s.forwardRef(/* @__PURE__ */ f(function(e, t) {
	let { __scopeSwitch: n, ...r } = e, i = _(S, n);
	return /* @__PURE__ */ l(a.span, {
		"data-state": D(i.checked),
		"data-disabled": i.disabled ? "" : void 0,
		...r,
		ref: t
	});
}, "SwitchThumb")), w = "SwitchBubbleInput", T = /* @__PURE__ */ s.forwardRef(/* @__PURE__ */ f(function({ __scopeSwitch: e, onClick: t, ...r }, c) {
	let { control: u, hasConsumerStoppedPropagationRef: d, userInteractionCount: f, checked: p, defaultChecked: m, required: h, disabled: g, name: v, value: y, form: b, bubbleInput: x, setBubbleInput: S } = _(w, e), C = i(c, S), T = o(u), E = s.useRef(!1), D = s.useRef(p), O = s.useRef(f);
	s.useEffect(() => {
		let e = x;
		if (!e) return;
		let t = window.HTMLInputElement.prototype, n = Object.getOwnPropertyDescriptor(t, "checked").set, r = f !== O.current;
		O.current = f;
		let i = D.current !== p;
		D.current = p;
		let a = !(r && d.current);
		if (i && n) {
			E.current = !r;
			let t = new Event("click", { bubbles: a });
			n.call(e, p), e.dispatchEvent(t), E.current = !1;
		}
	}, [
		x,
		p,
		d,
		f
	]);
	let k = s.useRef(p);
	return /* @__PURE__ */ l(a.input, {
		type: "checkbox",
		"aria-hidden": !0,
		defaultChecked: m ?? k.current,
		required: h,
		disabled: g,
		name: v,
		value: y,
		form: b,
		...r,
		tabIndex: -1,
		ref: C,
		onClick: n(t, (e) => {
			E.current && e.stopPropagation();
		}),
		style: {
			...r.style,
			...T,
			position: "absolute",
			pointerEvents: "none",
			opacity: 0,
			margin: 0,
			transform: "translateX(-100%)"
		}
	});
}, "SwitchBubbleInput"));
function E(e) {
	return typeof e == "function";
}
f(E, "isFunction");
function D(e) {
	return e ? "checked" : "unchecked";
}
f(D, "getState");
//#endregion
//#region src/foundations/switch/switch.tsx
var O = s.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ l(x, {
	className: e("peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input", t),
	...n,
	ref: r,
	children: /* @__PURE__ */ l(C, { className: e("pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0") })
}));
O.displayName = x.displayName;
//#endregion
export { O as t };

//# sourceMappingURL=switch-KuhNC7Bx.js.map